import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	PetitionDetailsPageFacebookExperiment,
	type PetitionDetailsPageFacebookExperimentQuery,
	type PetitionDetailsPageFacebookExperimentQueryVariables,
} from './facebookExperimentHeadline.graphql';

export async function getFacebookExperimentHeadline(
	experimentName: string,
	variantName: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<{ title: string; description: string } | undefined> {
	const { data } = await fetch<
		PetitionDetailsPageFacebookExperimentQuery,
		PetitionDetailsPageFacebookExperimentQueryVariables
	>({
		query: PetitionDetailsPageFacebookExperiment,
		rejectOnError: true,
	});

	const featureConfigData = data.fc.signatureGrowthPsfFbShareHeadlines;
	const { experimentName: fetchedExperimentName, variants } = featureConfigData;
	const variationData = variants[variantName as keyof typeof variants];

	if (!fetchedExperimentName || fetchedExperimentName !== experimentName) {
		throw new Error(`Experiment name ${experimentName} not found`);
	}

	if (!variationData) {
		throw new Error(`Variant name ${variantName} not found`);
	}

	const { title, description } = variationData;

	if (!title || !description) {
		throw new Error(`Title or description not found for variant ${variantName}`);
	}
	return {
		title,
		description,
	};
}
